import React from "react";
import PropTypes from "prop-types";
import "../styles/why-choose.css";

/**
 * WhyChoose
 *
 * Figma-aligned section:
 * - Paddings: L/R 110, T/B 67
 * - Background: white
 * - Decorative absolute image on the left
 * - Centered headline + 6 feature cards in a responsive grid
 *
 * A11y:
 * - <h2> section heading
 * - Features rendered as <ul><li> list for SRs
 */
const WhyChoose = ({
  title = "Why Choose The Avenue School?",
  leftDecorativeImage = "/media/dark-sage-leaf.png",
  features = [
    {
      title: "Small by Design",
      body:
        "We cap enrolments to ensure a calm, low-stimulation environment where every student feels known and supported.",
      icon: "/media/icons/small.svg",
    },
    {
      title: "Student-Centred",
      body:
        "Our staff are trained in trauma-informed practice and tailor learning to each student’s needs, interests, and goals.",
      icon: "/media/icons/student.png",
    },
    {
      title: "Flexible Pathways",
      body:
        "We offer the Victorian Pathways Certificate (VPC), with options that lead to VCE, vocational training, apprenticeships, or employment.",
      icon: "/media/icons/pathway.png",
    },
    {
      title: "Wellbeing Comes First",
      body:
        "Every student has a personalised wellbeing plan. Our youth workers and support staff provide counselling, referrals, and daily care.",
      icon: "/media/icons/wellbeing.png",
    },
    {
      title: "Real-World Learning",
      body:
        "From automotive design to nursing, we use students’ passions to teach literacy, numeracy, and life skills in engaging, practical ways.",
      icon: "/media/icons/real-world.png",
    },
    {
      title: "Inclusive & Safe",
      body:
        "We celebrate diversity, promote kindness, and uphold a strong commitment to child safety and respectful relationships.",
      icon: "/media/icons/inclusive.png",
    },
  ],
}) => {
  return (
    <section className="wc-section">
      {/* decorative absolute image */}
      <img
        className="wc-decor"
        src={leftDecorativeImage}
        alt=""
        aria-hidden="true"
      />

      {/* heading */}
      <h2 className="wc-title">{title}</h2>

      {/* features grid */}
      <ul className="wc-grid" role="list">
        {features.map((f, i) => (
          <li key={i} className="wc-card">
            <div className="wc-card-media" aria-hidden="true">
              <div className="wc-icon-bg" />
              {f.icon ? (
                <img className="wc-icon" src={f.icon} alt="" />
              ) : (
                <span className="wc-icon-dot" aria-hidden="true" />
              )}
            </div>

            <h3 className="wc-card-title">{f.title}</h3>
            <p className="wc-card-body">{f.body}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

WhyChoose.propTypes = {
  title: PropTypes.string,
  leftDecorativeImage: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ),
};

export default WhyChoose;
